<div class="footer-container">
    <div class="footer text-right padding-10 w-100">
        <div *ngIf="errorData" class="deep-link-error text-danger">
            <ng-template #popContent>
                <div *ngFor="let item of errorData" class="text-danger popover-content">
                    <acl-ngx-icon name="StatusWarning"></acl-ngx-icon>
                    <a class="text-danger"
                        (click)="scrollToErrorField(item.errorField, item.objectId, $event)"><b><u>{{item.columnKey}}:</u></b></a>{{item.errorMessage}}
                </div>
            </ng-template>
            <a class="text-danger" [ngbPopover]="popContent" placement="auto" [autoClose]="'outside'">
                <acl-ngx-icon name="StatusWarning"></acl-ngx-icon>
                <span class="error-count-text"><u>{{errorData.length}} errors need to be corrected before
                        saving.</u></span>
            </a>
        </div>
        <acl-ngx-icon *ngIf="isSaving" name="Process"></acl-ngx-icon>
        <acl-ngx-button contentClass="margin-5" variant="neutral" label="Cancel" [disabled]="isSaving"
            (click)="cancel()"></acl-ngx-button>
        <acl-ngx-button contentClass="margin-5" variant="neutral" label="Save Draft"
            [disabled]="isSaving || disableFooterButtonsBasedOnStatus" (click)="submit(planStatus.Draft.key)">
        </acl-ngx-button>
        <acl-ngx-button contentClass="margin-5" variant="primary" label="Generate Plan"
            [disabled]="isSaving || disableFooterButtonsBasedOnStatus" (click)="submit(planStatus.Pending.key)">
        </acl-ngx-button>
    </div>
</div>